import { render, staticRenderFns } from "./enterpriseCertification.vue?vue&type=template&id=5f9da226&scoped=true&"
import script from "./enterpriseCertification.vue?vue&type=script&lang=js&"
export * from "./enterpriseCertification.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseCertification.vue?vue&type=style&index=0&id=5f9da226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9da226",
  null
  
)

export default component.exports